import { render, staticRenderFns } from "./ChatCard.vue?vue&type=template&id=4d98d08c&scoped=true"
import script from "./ChatCard.vue?vue&type=script&lang=js"
export * from "./ChatCard.vue?vue&type=script&lang=js"
import style0 from "./ChatCard.vue?vue&type=style&index=0&id=4d98d08c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d98d08c",
  null
  
)

export default component.exports